// State name to abbreviation data, shared by the mini state icons and by
// abbreviation-aware searching. Keyed by the canonical state name the API
// returns in StateMetadata.state (e.g. 'New York', not 'new_york').

export const stateNameToAbbrev: { [stateName: string]: string } = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  DC: 'DC',
};

const abbrevToStateName: { [abbrev: string]: string } = Object.keys(
  stateNameToAbbrev,
).reduce((lookup: { [abbrev: string]: string }, stateName) => {
  lookup[stateNameToAbbrev[stateName].toLowerCase()] = stateName;
  return lookup;
}, {});

// Resolves a search query to a state name when the whole query is an
// abbreviation ('az' -> 'Arizona'). The match is deliberately exact rather than
// a substring one: 'a' would otherwise match most of the country, and 'in'
// would pull in every state whose abbreviation contains those letters.
export const stateNameForAbbreviation = (query: string): string | undefined =>
  abbrevToStateName[query.trim().toLowerCase()];
